import React, {useCallback} from 'react';
import { editBed } from '../../actions/beds';

const SectionTitle = ({ children }) => (
    <div style={{
        fontSize: 11, fontWeight: '700', textTransform: 'uppercase',
        letterSpacing: '0.8px', color: '#94a3b8', marginBottom: 12,
    }}>
        {children}
    </div>
);

const FieldLabel = ({ htmlFor, children }) => (
    <label htmlFor={htmlFor} style={{ fontSize: 12, color: '#64748b', marginBottom: 4, display: 'block', fontWeight: '500' }}>
        {children}
    </label>
);

const EditBedForm = (props) => {

    const validateForm = useCallback((event) => {
        event.preventDefault();
        const form = event.target;
        editBed(form).then((result) => {
            if (result) {
                setTimeout(function() {
                    window.location = "/dashboard";
                }.bind(this), 1000)
            }
        });
    },[]);

    return (
        <form onSubmit={validateForm} style={{
            backgroundColor: '#fff',
            border: '1px solid #e8ecef',
            borderRadius: 14,
            padding: '22px 26px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
        }}>
            <div style={{ fontWeight: '700', fontSize: 15, color: '#1a1a2e', marginBottom: 20 }}>
                Modifier les informations
            </div>

            <input id="number" type="hidden" defaultValue={props.bed.number} />

            {/* ── Affectation ── */}
            <SectionTitle>Affectation</SectionTitle>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                    <FieldLabel htmlFor="client">Client</FieldLabel>
                    <input
                        id="client" type="text"
                        defaultValue={props.bed.client}
                        className="form-control form-control-sm"
                        placeholder="Nom du client"
                    />
                </div>
                <div>
                    <FieldLabel htmlFor="pharmacy">Pharmacie</FieldLabel>
                    <select name="pharmacy" id="pharmacy" className="form-control form-control-sm">
                        <option value="Cremers"      selected={"Cremers"      === props.bed.pharmacy}>Cremers</option>
                        <option value="Violaines"    selected={"Violaines"    === props.bed.pharmacy}>Violaines</option>
                        <option value="Mont à Camp"  selected={"Mont à Camp"  === props.bed.pharmacy}>Mont à Camp</option>
                        <option value="Grand Stade"  selected={"Grand Stade"  === props.bed.pharmacy}>Grand Stade</option>
                    </select>
                </div>
            </div>
            <div style={{ marginBottom: 20 }}>
                <FieldLabel htmlFor="address">Adresse du client</FieldLabel>
                <input
                    id="address" type="text"
                    defaultValue={props.bed.address}
                    className="form-control form-control-sm"
                    placeholder="Adresse de livraison"
                />
            </div>
            <div style={{ marginBottom: 20 }}>
                <FieldLabel htmlFor="phone">Téléphone du client</FieldLabel>
                <input
                    id="phone" type="tel" inputMode="tel" autoComplete="tel"
                    defaultValue={props.bed.phone}
                    className="form-control form-control-sm"
                    placeholder="06 12 34 56 78"
                />
            </div>

            {/* ── Caractéristiques ── */}
            <SectionTitle>Caractéristiques</SectionTitle>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                    <FieldLabel htmlFor="model">Modèle</FieldLabel>
                    <select name="model" id="model" className="form-control form-control-sm">
                        <option value="Euro 1000"           selected={"Euro 1000"           === props.bed.model}>Euro 1000</option>
                        <option value="Euro 1000 Boiserie"  selected={"Euro 1000 Boiserie"  === props.bed.model}>Euro 1000 Boiserie</option>
                        <option value="Euro 1002"           selected={"Euro 1002"           === props.bed.model}>Euro 1002</option>
                        <option value="Euro 1600"           selected={"Euro 1600"           === props.bed.model}>Euro 1600</option>
                        <option value="Euro 3000"           selected={"Euro 3000"           === props.bed.model}>Euro 3000</option>
                        <option value="Sotec"               selected={"Sotec"               === props.bed.model}>Sotec</option>
                        <option value="Sotec (Gris Clair)"  selected={"Sotec (Gris Clair)"  === props.bed.model}>Sotec (Gris Clair)</option>
                        <option value="Autre"               selected={"Autre"               === props.bed.model}>Autre</option>
                    </select>
                </div>
                <div>
                    <FieldLabel htmlFor="motors">Moteurs</FieldLabel>
                    <input
                        id="motors" type="number"
                        defaultValue={props.bed.motors}
                        className="form-control form-control-sm"
                        pattern="[0-9]*" inputMode="numeric"
                    />
                </div>
                <div>
                    <FieldLabel htmlFor="year">Année</FieldLabel>
                    <input
                        id="year" type="number"
                        defaultValue={props.bed.year}
                        className="form-control form-control-sm"
                        pattern="[0-9]*" inputMode="numeric"
                    />
                </div>
            </div>
            <div style={{ marginBottom: 20 }}>
                <FieldLabel htmlFor="serialNumber">Numéro de série</FieldLabel>
                <input
                    id="serialNumber" type="text"
                    defaultValue={props.bed.serialNumber}
                    className="form-control form-control-sm"
                    placeholder="Ex : SN-12345"
                />
            </div>

            {/* ── Statut + submit ── */}
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                paddingTop: 16, borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 12,
            }}>
                <label htmlFor="isRent" style={{
                    display: 'flex', alignItems: 'center', gap: 10,
                    cursor: 'pointer', fontSize: 13, color: '#475569', margin: 0,
                }}>
                    <input
                        id="isRent" type="checkbox"
                        defaultChecked={props.bed.isRent}
                        className="form-check-input"
                        style={{ width: 18, height: 18, cursor: 'pointer', marginTop: 0 }}
                    />
                    <span style={{ fontWeight: '500' }}>En location</span>
                </label>
                <button type="submit" className="btn btn-primary btn-sm" style={{
                    borderRadius: 8, fontWeight: '600', padding: '8px 20px',
                }}>
                    Enregistrer les modifications
                </button>
            </div>
        </form>
    );
};

export {
    EditBedForm
};
